/*
  mk-menu-click.js — 8.10.2026 (Model Kids)
  Desktop glavni meni (.c-menu): klik na stavku prvog nivoa koja ima podmeni (bebe / mališani / deca) vodi direktno na
  stranicu te kategorije. Do sada je app.js (c-menu) na klik radio preventDefault, pa je klik samo držao podmeni otvoren.
  Hover i fokus tastaturom i dalje otvaraju podmeni (to ostaje u app.js). Mobilni meni (.c-mobile-menu) nije dirnut.
  Ne menja app.js: capture listener na samom linku se izvršava pre bubble listenera iz app.js i prekida ga
  (stopImmediatePropagation), pa pregledač uradi normalnu navigaciju. Ctrl/Cmd/Shift/srednji klik se ne diraju.
*/
(function () {
  'use strict';

  var links = document.querySelectorAll('.c-menu .c-menu__item > .c-nav-link--main');
  if (!links.length) return;

  Array.prototype.forEach.call(links, function (a) {
    var href = a.getAttribute('href');
    if (!href || href === '#') return;
    a.addEventListener('click', function (e) {
      if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
      e.stopImmediatePropagation(); /* app.js više ne stigne da uradi preventDefault */
      /* rezerva za starije pregledače (drugačiji redosled listenera): ako je ipak sprečeno, idi ručno */
      setTimeout(function () {
        if (e.defaultPrevented) window.location.assign(a.href);
      }, 0);
    }, true);
  });
})();
